import { mixins, styled } from '@bob/library'

export const Caption = styled.h5`
  width: 100%;
  ${mixins.typography.subtitleMedium};
  ${mixins.margin(0)};
`

export const Headline = styled.h1`
  width: 100%;
  ${mixins.typography.headlineXl};
  ${mixins.margin.top(20)};
  ${mixins.margin.bottom(50)};
  ${mixins.media.max.phone} {
    ${mixins.typography.headlineLarge};
  }
`

export const LearnMoreButtonWrapper = styled.div`
  text-align: center;
  ${mixins.margin(30)}
`
